import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ShortLongDescriptionComponent } from './short-long-description.component';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';

@NgModule({
  declarations: [ShortLongDescriptionComponent],
  imports: [CommonModule, PipesModule],
  exports: [ShortLongDescriptionComponent],
})
export class ShortLongDescriptionModule {}
